<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputPreview'
export default {
  name: 'DPhonePreview',
  extends: compoment
}
</script>
